import React, { useState } from 'react'
import styled from 'styled-components'
import AvatarEditor from 'react-avatar-editor'
import StyledSlider from 'components/StyledSlider'
import Typography from '@material-ui/core/Typography'
 
const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 115%;
  overflow-y: auto;
  margin-top: 75px;

  canvas {
    max-width: 350px !important;
    height: auto !important; 
  }
  
  @media screen and (max-width: 500px) {
    width: 100% !important;
    margin-top: 75px;
    max-width: 100%;
    
    canvas {
      width: 100% !important;
      height: auto !important;
    }
  }


`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2rem;
  border-radius: 1rem;
  background-color: white;
  margin-bottom: 150px;
`

const ScaleWrapper = styled.div`
  padding: 1rem 0;
`

const Button = styled.button`
  padding: 0.5rem 1rem;
  margin: 1rem 0;
  background: #07214C;
  color: white;
  border: 0;
  height: 60px;
`

const RotateButton = styled.button`
  flex: 1;
  padding: 0.5rem 1rem;
  margin-right: 1rem;
  background: #07214C;
  color: white;
  border: 0;
  height: 60px;
  &:last-child {
    margin-right: 0;
  }
`

const RotateButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

const marks = [
  {
    value: 0,
    label: '0x',
  },
  {
    value: 5,
    label: '5x',
  },
];

function AvatarCropper({
  onImageSave,
  image,
  ...props
}) {
  const editor = React.useRef(null);
  const [scale, setScale] = useState(1)
  const [rotate, setRotate] = useState(0)

  const saveImage = () => {
    const img = editor.current.getImageScaledToCanvas().toDataURL()
    const rect = editor.current.getCroppingRect()
    onImageSave && onImageSave(img)
  }

  const handleScale = (event, scale) => {
    setScale(scale)
  }

  const rotateLeft = e => {
    e.preventDefault()
    setRotate(rotate - 90)
  }

  const rotateRight = e => {
    e.preventDefault()
    setRotate(rotate + 90)
  }

  return (
      <Container>
        <Wrapper>
          <AvatarEditor
            ref={editor}
            image={image}
            width={500}
            height={500}
            border={0}
            scale={scale}
            borderRadius={1000}
            rotate={parseFloat(rotate)}
            {...props}
          />
          <ScaleWrapper>
            <Typography gutterBottom>
              Skaluj
            </Typography>
            <StyledSlider
              valueLabelDisplay="auto"
              defaultValue={scale}
              marks={marks}
              onChange={handleScale}
              step={0.1}
              min={0}
              max={5}
            />
          </ScaleWrapper>
          <Button onClick={saveImage}>ZATWIERDŹ</Button>
          <RotateButtonsContainer>
            <RotateButton onClick={rotateLeft}>OBRÓC W PRAWO</RotateButton>
            <RotateButton onClick={rotateRight}>OBRÓC W LEWO</RotateButton>
          </RotateButtonsContainer>
        </Wrapper>
      </Container>
  )
}
 
export default AvatarCropper